import { Record } from 'immutable'

const ClaimRecord = Record({
  type: undefined,
  value: undefined,
})

export default ClaimRecord
